import React, { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { FormikHelpers } from 'formik'
import { notification } from 'antd'
import {
  CompanyData,
  useCompany,
  useSaveCompany,
} from '../../../services/api/companies'
import { AsyncStates } from '../../../components'
import { View } from './View'
import { companyPath } from '../../../routes/paths'
import { isValidationError } from '../../../services/api/client/types'

const DEFAULT_COMMISSION_OPERATION = 'orders'

export const Container: React.FunctionComponent = () => {
  const { id } = useParams()
  const history = useHistory()
  const [
    getCompany,
    { isLoading, response, error: getCompanyError },
  ] = useCompany(id)
  const [saveCompany] = useSaveCompany(id)

  useEffect(() => {
    getCompany()
  }, [getCompany])

  const onSubmit = (
    form: CompanyData,
    { setErrors }: FormikHelpers<CompanyData>
  ) => {
    if (form.commission) {
      form.commission.operation = DEFAULT_COMMISSION_OPERATION
    }
    return saveCompany(form)
      .then(() => {
        history.push(companyPath(id))
        notification.success({
          message: 'Компания успешно обновлена',
          duration: 3,
        })
      })
      .catch((error) => {
        notification.error({
          message: 'Возникли ошибки при обновлении компании',
          duration: 3,
        })
        if (isValidationError(error)) {
          setErrors(error.fieldErrors)
        }
      })
  }

  return (
    <>
      <AsyncStates<CompanyData>
        isLoading={isLoading}
        error={getCompanyError}
        errorMessage="Не удалось загрузить компанию"
        reload={() => getCompany()}
        response={response}
        renderData={(company) => {
          const initialValues: CompanyData = { ...company }
          return <View initialValues={initialValues} onSubmit={onSubmit} />
        }}
      />
    </>
  )
}
